import { useEffect, useState } from 'react';

/**
 * Delays updates to a fast-changing value, such as a keystroke, so a
 * dependent computation or callback does not run once per character typed.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
